
export enum InvoiceStatus {
  InvoiceCreated = 0,
  InvoiceReceivedPayment = 1,
  InvoiceProcessing = 2,
  InvoiceExpired = 3,
  InvoiceSettled = 4,
  InvoiceInvalid = 5,
  InvoicePaymentSettled = 6
}

export type BTCPaymentInfo = {
  destination: string;
  amount: string;
  network_fee: string;
  invoice_id: string;
  type: "BTC" | "DOGE" | "LTC";
  status?: InvoiceStatus;
  product_id: string;
  expiration: string;
  payment_link: string;
};
